import React from 'react';
import { services, forWhoImage } from '../mock';
import { Check } from 'lucide-react';

const SectionTitle = ({ children, light }) => (
  <div className="flex items-center gap-3 mb-7">
    <span className={`block w-7 h-[2px] ${light ? 'bg-[#e30613]' : 'bg-[#e30613]'}`} />
    <h3 className={`font-bold tracking-[0.22em] text-[13px] ${light ? 'text-white' : 'text-[#1c1c1c]'}`}>
      {children}
    </h3>
  </div>
);

const Services = () => {
  return (
    <section id="dachy" className="bg-white">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10 py-16 grid lg:grid-cols-2 gap-10 items-stretch">
        {/* Services list */}
        <div className="py-2">
          <SectionTitle>ZAKRES USŁUG</SectionTitle>
          <ul className="space-y-4">
            {services.map((s) => (
              <li key={s} className="flex items-start gap-3 text-[14px] text-[#222]">
                <span className="mt-1 inline-flex w-4 h-4 shrink-0">
                  <Check size={16} className="text-[#e30613]" strokeWidth={3} />
                </span>
                <span>{s}</span>
              </li>
            ))}
          </ul>
        </div>

        {/* Dla kogo block */}
        <div className="relative grid md:grid-cols-2 bg-[#1a1a1a] overflow-hidden">
          <div className="p-8 md:p-10 flex flex-col">
            <SectionTitle light>DLA KOGO PRACUJEMY?</SectionTitle>
            <div className="space-y-4 text-white/80 text-[13.5px] leading-relaxed">
              <p>
                Dla Klientów, którzy oczekują rozwiązań przemyślanych i dopracowanych
                w każdym detalu.
              </p>
              <p>
                Dla osób, które rozumieją, że dach płaski jest układem technicznym,
                wymagającym doświadczenia i odpowiedzialności.
              </p>
              <p>
                Jeżeli Państwo oczekują podejścia systemowego, precyzji wykonania
                oraz realnej kontroli nad detalami — jesteśmy właściwym wyborem.
              </p>
            </div>
          </div>
          <div className="relative min-h-[260px] md:min-h-full">
            <img src={forWhoImage} alt="Nowoczesny dom z dachem płaskim" className="absolute inset-0 w-full h-full object-cover" />
            <div className="absolute inset-0 bg-gradient-to-r from-[#1a1a1a] via-transparent to-transparent md:from-[#1a1a1a]/90 md:via-[#1a1a1a]/10" />
          </div>
        </div>
      </div>
    </section>
  );
};

export default Services;
